import { ref } from 'vue';
import { addLuggage } from '@/features/application/addLuggage/api/addLuggage';

/**
 * 荷物追加のカスタムフック
 * @returns 荷物追加関連の状態と関数
 */
export const useAddLuggage = () => {
    const isLoading = ref(false);
    const errorMessage = ref<string>('');
    const successMessage = ref<string>('');

    /**
     * 荷物を追加する
     * @param applicationId - 申し込みID
     * @param luggageQrCode - 荷物QRコード
     * @returns 成功時はtrue、失敗時はfalse
     */
    const addLuggageToApplication = async (applicationId: string, luggageQrCode: string): Promise<boolean> => {
        try {
            isLoading.value = true;
            errorMessage.value = '';
            successMessage.value = '';

            await addLuggage(applicationId, luggageQrCode);

            successMessage.value = '荷物を正常に追加しました。';
            return true;
        } catch (error) {
            errorMessage.value = (error as Error).message;
            return false;
        } finally {
            isLoading.value = false;
        }
    };

    /**
     * エラーメッセージをクリアする
     */
    const clearError = () => {
        errorMessage.value = '';
    };

    /**
     * 成功メッセージをクリアする
     */
    const clearSuccess = () => {
        successMessage.value = '';
    };

    /**
     * すべてのメッセージをクリアする
     */
    const clearMessages = () => {
        errorMessage.value = '';
        successMessage.value = '';
    };

    return {
        isLoading,
        errorMessage,
        successMessage,
        addLuggageToApplication,
        clearError,
        clearSuccess,
        clearMessages,
    };
};
